import {
  changePasswordRequestSchema,
  emailInputSchema,
  loginRequestSchema,
  newPasswordSchema,
} from '@jaf/contracts';
import { z } from 'zod';

const emailField = emailInputSchema.pipe(z.email('E-mail inválido'));

/** Login: o mesmo schema da API, com checagem de formato do e-mail. */
export const loginFormSchema = loginRequestSchema.extend({ email: emailField });
export type LoginFormValues = z.infer<typeof loginFormSchema>;

/** "Esqueci minha senha". */
export const forgotPasswordFormSchema = z.object({ email: emailField });
export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordFormSchema>;

const confirmationMismatch = {
  message: 'As senhas não conferem',
  path: ['confirmation'],
};

/** Senha nova com confirmação (redefinição pelo link do e-mail). */
export const resetPasswordFormSchema = z
  .object({ newPassword: newPasswordSchema, confirmation: z.string() })
  .refine((values) => values.newPassword === values.confirmation, confirmationMismatch);
export type ResetPasswordFormValues = z.infer<typeof resetPasswordFormSchema>;

/** Troca de senha logado: senha atual + senha nova com confirmação. */
export const changePasswordFormSchema = changePasswordRequestSchema
  .extend({ confirmation: z.string() })
  .refine((values) => values.newPassword === values.confirmation, confirmationMismatch);
export type ChangePasswordFormValues = z.infer<typeof changePasswordFormSchema>;
